import React from "react";
import { styled } from "@mui/system";
import Chip, { ChipProps } from "@mui/material/Chip";

export type VaporBadgeProps = {
  bgColor?:
    | "red"
    | "orange"
    | "yellow"
    | "green"
    | "blue"
    | "purple"
    | "gray"
    | string;
  textColor?: string;
  borderColor?: string;
} & ChipProps;

export const VaporBadge: (props: VaporBadgeProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, VaporBadgeProps>((props, ref) => {
    const { bgColor, textColor, borderColor, ...otherProps } = props;
    return <Chip ref={ref} {...otherProps} />;
  }),
  {
    shouldForwardProp: (prop) =>
      prop !== ("bgColor" || prop !== "textColor") && prop !== "myProp",
    overridesResolver: (props, styles) => []
  }
)(({ theme, bgColor, textColor, borderColor }) => ({
  "&.MuiChip-root": {
    height: 24,
    borderRadius: 14,
    padding: "2px 8px",
    background:
      {
        red: "#F4C3C3",
        orange: "#FED6B8",
        yellow: "#FEE8B8",
        green: "#D1FFD1",
        blue: "#D5F4FB",
        purple: "#E6DCF4",
        gray: theme.palette.primary.neutral10Color
      }[bgColor] || bgColor,
    color:
      {
        red: "#450D0D",
        orange: "#4D2000",
        yellow: "#513701",
        green: "#054C19",
        blue: "#003F4D",
        purple: "#351C59",
        gray: "#1F292E"
      }[bgColor] || textColor,
    border: borderColor && `1px solid ${borderColor}`,
    "& .MuiChip-icon.MuiChip-iconColorDefault": {
      color:
        {
          red: "#450D0D",
          orange: "#4D2000",
          yellow: "#513701",
          green: "#054C19",
          blue: "#003F4D",
          purple: "#351C59",
          gray: "#1F292E"
        }[bgColor] || textColor,
      marginRight: 6,
      marginLeft: 0
    },
    "& .MuiChip-label": {
      padding: 0
    }
  }
}));
